<h5 [class]="compact ? 'col-4' : 'col-5'">
  {{ 'cartItems.description' | cxTranslate }}
</h5>
<div [class]="compact ? 'col-8' : 'col-7'">
  <div class="row">
    <h5 [class]="hideQuantity ? 'col-5' : 'col-3'" *ngIf="showPrice">
      {{ 'cartItems.itemPrice' | cxTranslate }}
    </h5>
    <h5 [class]="hideQuantity ? 'col-7 unit' : 'col-2 unit'">
      {{ 'cartItems.unit' | cxTranslate }}
    </h5>
    <h5 class="col-4" *ngIf="!hideQuantity">
      {{ 'cartItems.quantity' | cxTranslate }}
    </h5>
    <h5 class="col-3 text-right" *ngIf="showPrice && !hideQuantity">
      {{ 'cartItems.total' | cxTranslate }}
    </h5>
  </div>
</div>
